'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SleepPlanCtrl', SleepPlanCtrl);

  SleepPlanCtrl.$inject = ['$stateParams', 'sleepCheckInSvc', 'onboardingRouter', '$log'];

  function SleepPlanCtrl($stateParams, sleepCheckInSvc, onboardingRouter, $log) {
    var vm = this;
    vm.$onInit = activate;

    vm.next = _navigate;
    vm.context = onboardingRouter.getContext();
    vm.weeklyCheckIn = {
      id: $stateParams.cid
    };

    /////////////////
    function _navigate(checkIn) {
      if (!checkIn) {
        vm.weeklyCheckIn.checkInStatus = 'SKIP';
        sleepCheckInSvc.saveCheckIn(vm.weeklyCheckIn).then(function (resp) {
          $log.debug("Sleep Plan skipped");
          onboardingRouter.goToNextStep({ cid: resp }, {
            name: 'onboarding.mood.overlay'
          });
        });
      } else {
        onboardingRouter.goToNextStep({ cid: vm.weeklyCheckIn.id }, {
          name: 'onboarding.mood.overlay'
        });
      }
    }

    function activate() {}
  }
})();